import 'focus-visible';
import event from '../../event/js/module';
import clear from '../../clear/js/module';

/**
 * Toggle password visibility
 * @param dataElement - element which contains dataset and represents the trigger.
 * @param targetElement - password input element that will have its type toggled.
 */

// Listens for changes to the input field and toggles visibility button state
const listenToPasswordToggleButton = document.querySelectorAll("[data-element='toggle-password']")
  .forEach((toggleButton) => {
    const input = document.querySelector(toggleButton.dataset.togglePasswordTarget);
    input.addEventListener('input', (e) => {
      if (e.target.value === '') {
        toggleButton.classList.add('d-none');
      } else {
        toggleButton.classList.remove('d-none');
      }
    });
  });

// Handles toggle button on click and switches classes
const togglePasswordVisibilityOnClick = event.eventHandler(
  'toggle-password',
  'click',
  (dataElement, targetElement) => {
    const svgIcon = dataElement.querySelector('svg use');
    const currentHref = svgIcon.getAttribute('href');

    if (targetElement.type === 'password') {
      // eslint-disable-next-line no-param-reassign
      targetElement.type = 'text';
      dataElement.setAttribute('aria-label', 'Hide password');

      svgIcon.setAttribute('href', currentHref.replace('#icon-show', '#icon-hide'));
      dataElement.classList.remove('at-text-input__icon-show-password-icon');
      dataElement.classList.add('at-text-input__icon-mask-password-icon');
    } else {
      // eslint-disable-next-line no-param-reassign
      targetElement.type = 'password';
      dataElement.setAttribute('aria-label', 'Show password');

      svgIcon.setAttribute('href', currentHref.replace('#icon-hide', '#icon-show'));
      dataElement.classList.remove('at-text-input__icon-mask-password-icon');
      dataElement.classList.add('at-text-input__icon-show-password-button');
    }
  },
);

export default {
  event,
  clear,
  listenToPasswordToggleButton,
  togglePasswordVisibilityOnClick,
};
